export default {
  header: {
    title: 'Folosește-ți punctele',
    balance: '{{value}} pct disponibile',
  },
  option_label: '{{value}} pct',
  buttons: {
    none: 'Fără',
  },
  toasts: {
    enabled: 'Puncte de fidelitate aplicate cu succes',
    removed: 'Puncte de fidelitate eliminate',
  },
};
